import DentistDetails from './DentistDetails';

export default DentistDetails;
